import { State, Action, StateContext, Selector } from '@ngxs/store';
import { Customer } from '../models/customer.model';
import { Job } from '../models/job.model';
import { PreviousJob } from '../models/previousJob.model';
import { AddRenewMode, RemoveRenewMode, ClearRenewMode} from '../actions/renew-mode.action';
import { AddCustomer, UpdateCustomerList , RemoveCustomer, ClearCustomer } from '../actions/customer.action';
import { AddJob, UpdateJobList , RemoveJob, ClearJob } from '../actions/job.action';
import { AddPreviousJob, RemovePreviousJob, ClearPreviousJob } from '../actions/previousJob.action';
import { UpdateJobDetail, RemoveJobDetail, ClearJobDetail } from '../actions/job-detail.action';
import { JobDetail } from '../models/job-detail.model';
import { JobEquipment } from '../models/job-equipment.model';
import { UpdateJobEquipmentList, ClearJobEquipment } from '../actions/job-equipment.action';
import { RenewMode } from '../models/renew-mode.model';

export class JobMergeStateModel {
    customers: Customer[];
    jobs: Job[];
    jobDetail: JobDetail;
    jobEquipments: JobEquipment[];
    previousJob: PreviousJob;
    renewMode: RenewMode;
}

@State<JobMergeStateModel>({
    name: 'jobMerge',
    defaults: {
        customers: [],
        jobs: [],
        jobDetail: null,
        previousJob: null,
        jobEquipments: [],
        renewMode: null
    }
})

export class JobMergeState {

    @Selector()
    static getUsers(state: JobMergeStateModel) {
        return state.customers;
    }


    @Action(AddPreviousJob)
    addPreviousJob({getState, setState }: StateContext<JobMergeStateModel>, { payload }: AddPreviousJob) {
        const state = getState();
        setState({
            customers: state.customers,
            jobs: state.jobs,
            previousJob: payload,
            jobDetail: state.jobDetail,
            jobEquipments: state.jobEquipments,
            renewMode: state.renewMode
        });
    }

    @Action(AddRenewMode)
    addRenewMode({getState, setState }: StateContext<JobMergeStateModel>, { payload }: AddRenewMode) {
        const state = getState();
        setState({
            customers: state.customers,
            jobs: state.jobs,
            previousJob: state.previousJob,
            jobDetail: state.jobDetail,
            jobEquipments: state.jobEquipments,
            renewMode: payload
        });
    }

    @Action(ClearCustomer)
    clearCustomer({getState, setState }: StateContext<JobMergeStateModel>) {
        const state = getState();
        setState({
            customers: [],
            jobs: state.jobs,
            previousJob: state.previousJob,
            jobDetail: state.jobDetail,
            jobEquipments: state.jobEquipments,
            renewMode: state.renewMode
        });
    }

    @Action(ClearJob)
    clearJob({getState, setState }: StateContext<JobMergeStateModel>) {
        const state = getState();
        setState({
            customers: state.customers,
            jobs: [],
            previousJob: state.previousJob,
            jobDetail: state.jobDetail,
            jobEquipments: state.jobEquipments,
            renewMode: state.renewMode

        });
    }

    @Action(ClearJobDetail)
    clearJobDetail({getState, setState }: StateContext<JobMergeStateModel>) {
        const state = getState();
        setState({
            customers: state.customers,
            jobs: state.jobs,
            previousJob: state.previousJob,
            jobDetail: null,
            jobEquipments: state.jobEquipments,
            renewMode: state.renewMode
        });
    }

    @Action(ClearJobEquipment)
    clearJobEquipment({getState, setState }: StateContext<JobMergeStateModel>) {
        const state = getState();
        setState({
            customers: state.customers,
            jobs: state.jobs,
            previousJob: state.previousJob,
            jobDetail: state.jobDetail,
            jobEquipments: [],
            renewMode: state.renewMode
        });
    }

    @Action(ClearPreviousJob)
    clearPreviousJob({getState, setState }: StateContext<JobMergeStateModel>) {
        const state = getState();
        setState({
            customers: state.customers,
            jobs: state.jobs,
            previousJob: null,
            jobDetail: state.jobDetail,
            jobEquipments: state.jobEquipments,
            renewMode: state.renewMode
        });
    }

    @Action(ClearRenewMode)
    clearRenewMode({getState, setState }: StateContext<JobMergeStateModel>) {
        const state = getState();
        setState({
            customers: state.customers,
            jobs: state.jobs,
            previousJob: state.previousJob,
            jobDetail: state.jobDetail,
            jobEquipments: state.jobEquipments,
            renewMode: null
        });
    }


    @Action(UpdateCustomerList)
    updateList({getState, setState }: StateContext<JobMergeStateModel>,  {payload}: UpdateCustomerList) {
        const state = getState();
        setState({
            customers: [...payload],
            jobs: [],
            previousJob: state.previousJob,
            jobDetail: null,
            jobEquipments: [],
            renewMode: state.renewMode
        });
    }

    @Action(UpdateJobList)
    updateJobList({getState, setState }: StateContext<JobMergeStateModel>,  {payload}: UpdateJobList) {
        const state = getState();
        setState({
            customers: state.customers,
            jobs: [...payload],
            previousJob: state.previousJob,
            jobDetail: null,
            jobEquipments: [],
            renewMode: state.renewMode
        });
    }

    @Action(UpdateJobDetail)
    updateJobDetail({getState, setState }: StateContext<JobMergeStateModel>,  {payload}: UpdateJobDetail) {
        const state = getState();
        setState({
            customers: state.customers,
            jobs: state.jobs,
            previousJob: state.previousJob,
            jobDetail: payload,
            jobEquipments: [],
            renewMode: state.renewMode
        });
    }

    @Action(UpdateJobEquipmentList)
    updateJobEquipmentList({getState, setState }: StateContext<JobMergeStateModel>,  {payload}: UpdateJobEquipmentList) {
        const state = getState();
        setState({
            customers: state.customers,
            jobs: state.jobs,
            previousJob: state.previousJob,
            jobDetail: state.jobDetail,
            jobEquipments: [...payload],
            renewMode: state.renewMode
        });
    }

    @Action(RemoveCustomer)
    remove({getState, setState }: StateContext<JobMergeStateModel>, { payload }: RemoveCustomer) {
        const state = getState();
        const customers = state.customers.filter(x => x.id !== payload.id);
        setState({
            customers: customers,
            jobs: [],
            previousJob: state.previousJob,
            jobDetail: null,
            jobEquipments: [],
            renewMode: state.renewMode
        });
    }

    @Action(RemoveJob)
    removeJob({getState, setState }: StateContext<JobMergeStateModel>, { payload }: RemoveJob) {
        const state = getState();
        const jobs = state.jobs.filter(x => x.jobNumber !== payload.jobNumber);
        setState({
            customers: state.customers,
            jobs: jobs,
            previousJob: state.previousJob,
            jobDetail: null,
            jobEquipments: [],
            renewMode: state.renewMode
        });
    }

    @Action(RemoveJobDetail)
    removeJobDetail({getState, setState }: StateContext<JobMergeStateModel>, { payload }: RemoveJobDetail) {
        const state = getState();
        setState({
            customers: state.customers,
            jobs: state.jobs,
            previousJob: state.previousJob,
            jobDetail: null,
            jobEquipments: [],
            renewMode: state.renewMode
        });
    }

    @Action(RemovePreviousJob)
    removePreviousJob({getState, setState }: StateContext<JobMergeStateModel>, { payload }: RemovePreviousJob) {
        const state = getState();
        setState({
            customers: [],
            jobs: [],
            previousJob: null,
            jobDetail: null,
            jobEquipments: [],
            renewMode: state.renewMode
        });
    }


}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/job/job-merge-customer/state/job-merge.state.ts